import React from "react";
import { connect } from "react-redux";

import Storage from "./util/Storage";
import Cookie from "./util/Cookie";
import {fetchData} from "./store/action";

class OneSignal extends React.Component{

    constructor(props){
        super(props)
        this.registerWithOneSignal = this.registerWithOneSignal.bind(this);
    }

    componentWillMount(){
        const { fetchData } = this.props;
        const oneSignalAppId = Cookie.get('oneSignalAppId');
        var OneSignal = window.OneSignal || [];
        
        OneSignal.push(()=> {
            OneSignal.init({
                appId: oneSignalAppId,
                autoRegister: false,
                notifyButton: {
                    enable: true,
                },
            });
        });
        
        OneSignal.push(() => {
          // Occurs when the user's subscription changes to a new value.
          OneSignal.on('subscriptionChange', (isSubscribed) => {
            // const authToken = Cookie.get("X-Reycreo-Auth-Token");
            // const user_id = Cookie.get("X-Reycreo-Id");  
            if(isSubscribed){
                OneSignal.getUserId((userId)=>{
                    fetchData({
                        noLoading: true,
                        method:'POST',
                        uri: `/registerNotifUser/${userId}`,
                        onSuccess: _=>{
                            Storage.set("registerWithOneSignal", true);
                        }
                    })
                })
              }
          });
        });
        // const checkForRegister = Storage.get("registerWithOneSignal");
        // if(!checkForRegister){
        //     this.registerWithOneSignal();
        // }
    }

    registerWithOneSignal(){
        const { fetchData } = this.props;
        const authToken = Cookie.get("X-Reycreo-Auth-Token");
        const user_id = Cookie.get("X-Reycreo-Id");
        var OneSignal = window.OneSignal || [];
        if(authToken && user_id && OneSignal && OneSignal.getUserId){
            OneSignal.getUserId((userId)=>{
                console.log("OneSignal userId",userId);
                if(userId){
                    fetchData({
                        noLoading: true,
                        method:'POST',
                        uri: `/registerNotifUser/${userId}`,
                        onSuccess: _=>{
                            Storage.set("registerWithOneSignal", true);
                        }
                    })
                }
            })
        }
    }
    render(){
      return null
    }
}

export default OneSignal = connect((state, ownProps) => {
    return state.data;
}, {
    fetchData,
})(OneSignal);


// WEBPACK FOOTER //
// ./src/OneSignal.js